import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CategoryList from "../../features/manageCategories/categoryList";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import AddCategory from "../../Modals/addCategory";
import { useEffect, useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import FilterMenu from "../../components/filterMenu";
import { isValidInput } from "../../utils/validations";
import {
  useLazyGetCategoryQuery,
  useLazyGetInternalProcessQuery,
} from "../../service/category";
import { showError } from "../../constants/toasts";
import { Categories } from "../../types/General";
import Loader from "../../constants/Loader";
import InternalProcessList from "../../features/manageCategories/internalProcessList";
import AddInternalProcess from "../../Modals/addInternalProcess";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCategories = () => {
  const navigate = useNavigate();
  const [getCategory] = useLazyGetCategoryQuery();
  const [getInternalProcess] = useLazyGetInternalProcessQuery();
  const [categoryData, setCategoryData] = useState<Categories[]>([]);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedProcessId, setSelectedProcessId] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<Categories | null>(
    null
  );
  const [open1, setOpen1] = useState(false);
  const [selectedProcess, setSelectedProcess] = useState<any>(null);

  const [internalData, setInternalData] = useState([]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [valueTabs1, setValueTabs1] = useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [loading, setLoading] = useState(false);

  const getCategoryApi = async () => {
    setLoading(true);
    try {
      const response = await getCategory({
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setCategoryData(response?.data || []);
      } else {
        setCategoryData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getInternalProcessApi = async () => {
    setLoading(true);
    try {
      const response = await getInternalProcess({
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setInternalData(response?.data || []);
      } else {
        setInternalData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (valueTabs1 === 0) {
      getCategoryApi();
    } else {
      getInternalProcessApi();
    }
  }, [debouncedSearchTerm, page, valueTabs1]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <h1>Manage Categories</h1>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (valueTabs1 === 0) {
                  setOpen(true);
                } else {
                  setOpen1(true);
                }

                setSelectedId("");
                setSelectedCategory(null);
              }}
            >
              + Add New Category
            </Button>
            <FilterMenu
              startDate={null}
              endDate={null}
              setStartDate={() => { }}
              setEndDate={() => { }}
            />
          </div>
        </div>

        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Offer" {...a11yProps(0)} />
              <Tab label="Internal Process" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs1} index={0}>
            <CategoryList
              activeTab={0}
              data={categoryData}
              page={page}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              getCategoryApi={getCategoryApi}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            <InternalProcessList
              activeTab={1}
              data={internalData}
              page={page}
              selectedCategory={selectedProcess}
              setSelectedCategory={setSelectedProcess}
              selectedId={selectedProcessId}
              setSelectedId={setSelectedProcessId}
              getInternalProcessApi={getInternalProcessApi}
            />
          </CustomTabPanel>
        </div>
        {valueTabs1 === 1 ? <CustomPagination /> : null}
      </MainContainer>
      <AddCategory
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        selectedCategory={selectedCategory}
        selectedId={selectedId}
        getCategoryApi={getCategoryApi}
      />
      <AddInternalProcess
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
        selectedCategory={selectedCategory}
        selectedId={selectedId}
        getProcessApi={getInternalProcessApi}
      />
    </>
  );
};
export default ManageCategories;
